export const ROUTE_BREADCRUMB_MAP: any = {
  '/dashboard/document-editing/edit': ['Proposals', 'Edit Proposal'],
  '/dashboard/document-editing/create': ['Proposals', 'New Proposal'],
  '/dashboard/list-proposals': ['Proposals'],
  '/dashboard/crm': ['Customer Relationship Management'],
  '/dashboard/crm/crm-overview': ['Customer Relationship Management'],
  '/dashboard/crm/crm-leads': ['Customer Relationship Management'],
  '/dashboard/crm-details/leads': ['Customer Relationship Management', 'Leads', 'Lead Info'],
  '/dashboard/crm/crm-opportunities': ['Customer Relationship Management'],
  '/dashboard/crm-details/opportunity' : ['Customer Relationship Management', 'Opportunity', 'Opportunity Info'],
  '/dashboard/crm-details/proposals' : ['Customer Relationship Management', 'Proposals', 'Proposals Info'],
  '/dashboard/proposals/view-document': ['Customer Relationship Management', 'Proposals', 'View Proposal'],
  '/dashboard/crm/crm-projects': ['Customer Relationship Management'],
  '/dashboard/proposals/document-editor': ['Customer Relationship Management' , 'proposals', 'document-editor'],
  '/dashboard/proposals/full-document-editor': ['Customer Relationship Management' , 'proposals', 'full-document-editor'],
  '/dashboard/proposals/document-viewer':['Customer Relationship Management', 'Proposals', 'Proposal Viewer'],
  '/dashboard/projects/project-info': ['Customer Relationship Management', 'Project', 'Project Info'],
  '/dashboard/crm-details/client': ['Customer Relationship Management', 'Client', 'Client Info'],
  '/dashboard/crm-details/won-lost': ['Customer Relationship Management', 'Won/Lost', 'Won/Lost Info'],
  '/dashboard/settings/organization-details': ['Settings'],
  '/dashboard/crm-details/go-no-go': ['Customer Relationship Management', 'Go/No-Go Decisions', 'Go/No-Go Info'],
  '/dashboard/settings/edit-organization-details': ['Settings','Organization Info','Edit Organization'],
  '/dashboard/settings/user-management': ['Settings'],
  '/dashboard/settings/roles-&-permissions': ['Settings'],
  '/dashboard/settings/crm-configuration': ['Settings'],
  '/dashboard/settings/announcements': ['Settings'],
  '/dashboard/user-info-add': ['Settings', 'Employee','Add Employee'],
  '/dashboard/user-info-edit': ['Settings', 'Employee', 'Edit Employee'],
  '/dashboard/edit-roles-details': ['Settings', 'Roles & Permissions', 'Edit Roles'],
  '/dashboard/add-roles-details': ['Settings', 'Roles & Permissions', 'Add Roles'],
  '/dashboard/settings/edit-details': ['Organization Details', 'Settings', 'Edit Details'],
  '/dashboard/settings/add-office-location': ['Organization Details', 'Settings', 'Add Office Location'],
  '/dashboard/settings/edit-office-location': ['Organization Details', 'Settings', 'Edit Office Location'],
   '/dashboard/client-management/client-details': ['Client Management'],
  '/dashboard/client-management/add-client-details': ['Client Management', 'Client Details', 'Add New Client'],
  '/dashboard/client-management/edit-client-details': ['Client Management', 'Client Details', 'Edit Client Details'],
  '/dashboard/client-management/view-client-details': ['Client Management', 'Client Details', 'View Client Details'],
  '/dashboard/assets': ['Asset Management'],
  '/dashboard/assets/summary': ['Asset Management'],
  '/dashboard/assets/assets-&-equipments': ['Asset Management', 'Hardware Assets'],
  '/dashboard/assets/assets-&-equipments/asset-details': ['Asset Management', 'Hardware Assets', 'Asset Details'],
  '/dashboard/assets/software-license': ['Asset Management', 'Software Licenses'],
  '/dashboard/assets/license-utilization': ['Asset Management', 'License Utilization'],
  '/dashboard/assets/employee-usage': ['Asset Management', 'Assignments'],
  '/dashboard/view-employee-usage': ['Asset Management', 'Assignments'],
  '/dashboard/assets/provisioning-requests': ['Asset Management', 'Provisioning Requests'],
  '/dashboard/assets/asset-configuration': ['Asset Management', 'Configuration'],
  '/dashboard/assets/configuration': ['Asset Management', 'Configuration'],
  '/dashboard/my-assets/requests': ['Assets Management'],
  '/dashboard/my-assets/activity': ['Assets Management'],
  '/dashboard/my-assets/assets-softwares': ['Assets Management'],
  '/dashboard/assets/software-license/software-details': ['Asset Management', 'Software Licenses', 'Software Details'],
  '/dashboard/my-project': ['My Projects'],
  '/dashboard/support-projects': ['Support Projects'],
  '/dashboard/my-team': ['my-team'],
  '/dashboard/project-management/allocation': ['My Projects', 'Workplan'],
  '/dashboard/project-management/work-plan': ['My Projects', 'Work Plan'],
  '/dashboard/project-management/project-details': ['My Projects', 'Project Details'],
  '/dashboard/project-management/directory': ['My Projects', 'Project Details'],
  '/dashboard/project-management/documents': ['My Projects', 'Documents'],
  '/dashboard/project-management/project-details-docs': ['My Projects', 'Documents'],
  '/dashboard/project-management/project-timesheet': ['My Projects', 'Timesheets'],
  '/dashboard/project-management/project-timesheet-approval': ['My Projects', 'Timesheet Approval'],
  '/dashboard/timesheet/timesheet-approval': ['Timesheet', 'Timesheet Approval'],
  '/dashboard/project-management/project-team': ['My Projects', 'Project Team'],
  '/dashboard/project-management/project-feedback': ['My Projects', 'Project Feedback'],
  '/dashboard/project-management/discussion': ['My Projects', 'Discussion'],
  '/dashboard/project-management/project-notes': ['My Projects', 'Additional Notes'],
  '/dashboard/project-management/project-score': ['My Projects', 'Project Score'],
  '/dashboard/project-management/summary': ['My Projects', 'Overview'],
  '/dashboard/project-management/project-setup': ['My Projects', 'Skill Configuration'],
  '/dashboard/finance': ['Finance'],
  '/dashboard/invoice-peer-review': ['Peer Review'],
  '/dashboard/invoice-manager-review': ['Invoice Review'],
};
